import { reachesBeyondOwnRequests } from './fgaRules'
import { resolveAccess } from './resolveAccess'
import { adminsOnly } from './roleAuthorization'
import { useAccessSources } from './useAccessSources'
import type { NonRecordAccessRule } from './accessRules'

export const REACHES_BEYOND_OWN_REQUESTS = {
  authorization: { kind: 'fgaOrRole', fga: reachesBeyondOwnRequests, role: adminsOnly },
} as const satisfies NonRecordAccessRule

/**
 * Whether the requests list and dashboard offer the organisation views rather than the caller's own requests —
 * the rule the list and stats endpoints enforce. `undefined` until the answer settles; one that cannot settle
 * reads as no, which offers only views every caller may use.
 */
export const useReachesBeyondOwnRequests = (): boolean | undefined => {
  const answer = resolveAccess(REACHES_BEYOND_OWN_REQUESTS, useAccessSources())
  return answer === 'pending' ? undefined : answer === 'allowed'
}
